import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const AccessLinkSpaceAdminControlsLoader: LoadableType<{
	spaceKey?: string;
}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-AccessLinkSpaceAdminControls" */ './components/AccessLinkSpaceAdminControls.tsx'
			)
		).AccessLinkSpaceAdminControls,
});
